import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface SEOSchemaProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  schema?: Record<string, unknown>[];
}

function updateMeta(name: string, content: string, attrName = 'name') {
  let el = document.querySelector(`meta[${attrName}="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attrName, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function updateLink(rel: string, href: string) {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export default function SEOSchema({
  title = '91牛官网 - 91牛平台介绍与服务',
  description = '91牛是专业平台，为用户提供优质服务与资源。了解91牛的核心功能、用户评价及使用指南，立即体验91牛带来的便捷与价值，加入91牛用户社区，开启全新体验。',
  keywords = '91牛,91牛官网,91牛平台,91牛注册,91牛使用教程',
  canonicalUrl,
  ogType = 'website',
  schema,
}: SEOSchemaProps) {
  const location = useLocation();
  const url = canonicalUrl || `https://qx-ly.cn${location.pathname}`;

  useEffect(() => {
    document.title = title;
    updateMeta('description', description);
    updateMeta('keywords', keywords);
    updateLink('canonical', url);
    updateMeta('og:title', title, 'property');
    updateMeta('og:description', description, 'property');
    updateMeta('og:type', ogType, 'property');
    updateMeta('og:url', url, 'property');
    updateMeta('og:locale', 'zh_CN', 'property');
    updateMeta('twitter:card', 'summary_large_image');
    updateMeta('twitter:title', title);
    updateMeta('twitter:description', description);
  }, [title, description, keywords, url, ogType]);

  useEffect(() => {
    const schemaId = 'seo-jsonld';
    const existing = document.getElementById(schemaId);
    if (existing) existing.remove();
    if (schema && schema.length > 0) {
      const script = document.createElement('script');
      script.id = schemaId;
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(schema.length === 1 ? schema[0] : schema);
      document.head.appendChild(script);
    }
    return () => {
      const el = document.getElementById(schemaId);
      if (el) el.remove();
    };
  }, [schema]);

  return null;
}